// Schmaler Fetch-Wrapper. Cookies gehen automatisch mit (Same-Origin);
// es gibt bewusst keine Token-Verwaltung im Browser.

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public issues?: Array<{ path: string; message: string }>,
    public data?: unknown,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'
  body?: unknown
  headers?: Record<string, string>
}

export async function apiFetch<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const res = await fetch(`/api/v1${path}`, {
    method: opts.method ?? 'GET',
    credentials: 'same-origin',
    headers: {
      ...(opts.body ? { 'content-type': 'application/json' } : {}),
      ...opts.headers,
    },
    ...(opts.body ? { body: JSON.stringify(opts.body) } : {}),
  })

  if (res.status === 204) return undefined as T

  const text = await res.text()
  const data = text ? safeParse(text) : undefined

  if (!res.ok) {
    const payload = data as
      | { error?: string; message?: string; issues?: Array<{ path: string; message: string }> }
      | undefined
    throw new ApiError(
      res.status,
      payload?.error ?? 'unknown',
      payload?.message ?? `Anfrage fehlgeschlagen (HTTP ${res.status}).`,
      payload?.issues,
      payload,
    )
  }

  return data as T
}

function safeParse(text: string): unknown {
  try {
    return JSON.parse(text)
  } catch {
    return undefined
  }
}
